import { getExtension } from "@/app/[locale]/(client)/chats/components/chat/components/upload-dialog";
import { MediaItem } from "@/lib/media/shared";

export function resolveProcessingProfile(file: File): string {
  if (file.type.startsWith("image/")) return "listing_draft";
  if (file.type.startsWith("video/")) return "video";
  return "document";
}

export async function uploadListingMedia(
  file: File,
  category: "image" | "video" | "document",
  listingId: string,
  watermarkUrl: string,
): Promise<MediaItem> {
  // <-- NOW RETURNS MediaItem
  const fileExtension = getExtension(file.name);
  if (!fileExtension) throw new Error("Missing extension");

  const processingProfile = resolveProcessingProfile(file);

  // 1. PRESIGN
  const presignRes = await fetch("/api/media/presign", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      MediaCategory: category,
      ProcessingProfile: processingProfile,
      ContentType: file.type,
      FileExtension: fileExtension,
      OriginalFileName: file.name,
    }),
  });

  if (!presignRes.ok) throw new Error("Presign failed");
  const presignData = await presignRes.json();

  // 2. UPLOAD TO S3
  await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error("Upload failed"));
    };
    xhr.onerror = () => reject(new Error("Network error"));
    xhr.open("PUT", presignData.UploadUrl);
    xhr.setRequestHeader("Content-Type", file.type);
    xhr.send(file);
  });

  // 3. TRIGGER PIPELINE
  const triggerRes = await fetch(`/api/media/triggerUploadComplete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      MediaId: presignData.MediaId,
      Source: "listing_creation",
      WatermarkURL: watermarkUrl,
      AttachedTo: {
        EntityType: "listing",
        PK: { ListingId: listingId },
      },
    }),
  });

  if (!triggerRes.ok) throw new Error("Failed to trigger processing pipeline");

  // The backend now returns the full MediaItem directly!
  const finalMediaData = await triggerRes.json();

  return {
    ...finalMediaData,
    OriginalFileName: file.name,
    FileExtension: fileExtension,
    RawKey:
      finalMediaData.RawKey ||
      `drafts/${finalMediaData.MediaId}/source.${fileExtension}`,
  };
}
